import * as R from 'ramda';
import { useMemo } from 'react';
import { useUserContextPreferences } from '../../../hooks/useUserContextPreferences';
import { ColumnsPreferenceRecognizedLists } from '../../../services/modules/userContextPreferences/userContextPreferences.types';
import { Column } from '../components/table/VirtualizedTable.types';

const useTableColumns = <T>(
  columns: Column<T>[],
  columnsPreferenceRecognizedList?: ColumnsPreferenceRecognizedLists,
) => {
  const { userContextPreferences } = useUserContextPreferences();

  const savedColumns =
    columnsPreferenceRecognizedList &&
    userContextPreferences?.columnsPreferences?.find(
      ({ list }) => list === columnsPreferenceRecognizedList,
    )?.defaultColumns;

  const columnsToShow = savedColumns
    ? columns.filter((column) => {
        if (savedColumns?.includes(column.name)) {
          return true;
        }

        return column.canHide === false;
      })
    : columns.filter((column) => column.showByDefault !== false);

  const defaultColumns = useMemo(
    () =>
      columns
        .filter((column) => (R.isNil(column.showByDefault) ? true : column.showByDefault))
        .map((c) => c.name),
    [columns],
  );

  const canRestoreToDefaultColumns = !R.equals(defaultColumns, savedColumns);

  return { columnsToShow, canRestoreToDefaultColumns };
};

export default useTableColumns;
